// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/no-anonymous-default-export */
export default {
  appId: 262304,
  actId: 30111563,
  appName: '',
  region: 'SG',
  enableShark: false,
  title: '赛季回顾中转页',
  description: '描述',
  image: '',
  ppe: ''
};
